/**
 * Texto com formatação (negrito, itálico, sublinhado, listas) gravado como HTML
 * pelo editor Quill. Textos antigos, gravados antes da formatação, são texto
 * puro: estas funções tratam os dois formatos sem migrar o banco.
 */

const HTML_TAG = /<\/?[a-z][^>]*>/i;

/** O valor já é HTML do editor (e não um texto puro antigo). */
export function isRichText(value) {
  return typeof value === 'string' && HTML_TAG.test(value);
}

function escapeHtml(text) {
  return text
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;');
}

/** Converte um texto puro antigo para o HTML do editor, uma linha por parágrafo. */
export function toRichText(value) {
  const text = typeof value === 'string' ? value : '';
  if (text === '' || isRichText(text)) return text;
  return text
    .split('\n')
    .map((line) => `<p>${line === '' ? '<br>' : escapeHtml(line)}</p>`)
    .join('');
}

/** Só o texto, sem as marcações (contagem de caracteres, campo vazio). */
export function richTextToPlain(value) {
  if (!isRichText(value)) return typeof value === 'string' ? value : '';
  // DOMParser não executa scripts nem carrega imagens do conteúdo
  const doc = new DOMParser().parseFromString(value, 'text/html');
  return doc.body.textContent || '';
}

/** O editor vazio ainda guarda `<p><br></p>`: conta como sem texto. */
export function isRichTextEmpty(value) {
  return richTextToPlain(value).trim() === '';
}
